import { EnumOptionsList } from "@/types/common";
import { FactoryInventorySourceType, FactoryOptEnum, FactoryDirectionEnum } from "@/types/factoryInventory";
import { useTranslation } from "react-i18next";

const useFactoryEnums = (addVn = false) => {
  const { t } = useTranslation();

  const SourceTypeList: EnumOptionsList<FactoryInventorySourceType>[] = [
    {
      key: FactoryInventorySourceType.MANUAL,
      value: FactoryInventorySourceType.MANUAL,
      color: "blue",
      label: addVn ? `${t('warehouse.manual', { lng: "zh" })}/${t('warehouse.manual', { lng: "vn" })}` : t('warehouse.manual')
    },
    {
      key: FactoryInventorySourceType.PRODUCTION,
      value: FactoryInventorySourceType.PRODUCTION,
      color: "green",
      label: addVn ? `${t('warehouse.production', { lng: "zh" })}/${t('warehouse.production', { lng: "vn" })}` : t('warehouse.production')
    },
    {
      key: FactoryInventorySourceType.PURCHASE,
      value: FactoryInventorySourceType.PURCHASE,
      color: "gold",
      label: addVn ? `${t('warehouse.purchase', { lng: "zh" })}/${t('warehouse.purchase', { lng: "vn" })}` : t('warehouse.purchase')
    },
    {
      key: FactoryInventorySourceType.SALE,
      value: FactoryInventorySourceType.SALE,
      color: "orange",
      label: addVn ? `${t('warehouse.sale', { lng: "zh" })}/${t('warehouse.sale', { lng: "vn" })}` : t('warehouse.sale')
    },
    {
      key: FactoryInventorySourceType.REQUIREMENT,
      value: FactoryInventorySourceType.REQUIREMENT,
      color: "magenta",
      label: addVn ? `${t('layout.requirementList', { lng: "zh" })}/${t('layout.requirementList', { lng: "vn" })}` : t('layout.requirementList')
    },
    {
      key: FactoryInventorySourceType.OTHER,
      value: FactoryInventorySourceType.OTHER,
      color: "purple",
      label: addVn ? `${t('warehouse.other', { lng: "zh" })}/${t('warehouse.other', { lng: "vn" })}` : t('warehouse.other')
    },
  ];

  const getSourceType = (value: FactoryInventorySourceType | null) => {
    if (value === null) return
    return SourceTypeList.find(i => i.value === value)
  };

  const opTypeList: EnumOptionsList<FactoryOptEnum>[] = [
    {
      key: FactoryOptEnum.BATCH_ADD,
      value: FactoryOptEnum.BATCH_ADD,
      color: "green",
      label: addVn ? `${t('inventory.batchAdd', { lng: "zh" })}/${t('inventory.batchAdd', { lng: "vn" })}` : t('inventory.batchAdd')
    },
    {
      key: FactoryOptEnum.ADJUST,
      value: FactoryOptEnum.ADJUST,
      color: "orange",
      label: addVn ? `${t('inventory.adjust', { lng: "zh" })}/${t('inventory.adjust', { lng: "vn" })}` : t('inventory.adjust')
    },
    {
      key: FactoryOptEnum.COUNT,
      value: FactoryOptEnum.COUNT,
      color: "blue",
      label: addVn ? `${t('inventory.count', { lng: "zh" })}/${t('inventory.count', { lng: "vn" })}` : t('inventory.count')
    },
  ];

  const getOpType = (value: FactoryOptEnum | null) => {
    if (value === null) return
    return opTypeList.find(i => i.value === value)
  };

  const directionList: EnumOptionsList<FactoryDirectionEnum>[] = [
    {
      key: FactoryDirectionEnum.INBOUND,
      value: FactoryDirectionEnum.INBOUND,
      color: "green",
      label: addVn ? `${t('warehouse.inbound', { lng: "zh" })}/${t('warehouse.inbound', { lng: "vn" })}` : t('warehouse.inbound')
    },
    {
      key: FactoryDirectionEnum.OUTBOUND,
      value: FactoryDirectionEnum.OUTBOUND,
      color: "orange",
      label: addVn ? `${t('warehouse.outbound', { lng: "zh" })}/${t('warehouse.outbound', { lng: "vn" })}` : t('warehouse.outbound')
    },
  ];

  const getDirection = (value: FactoryDirectionEnum | null) => {
    if (value === null) return
    return directionList.find(i => i.value === value)
  };

  return {
    SourceTypeList,
    getSourceType,
    opTypeList,
    getOpType,
    directionList,
    getDirection
  }
};

export default useFactoryEnums;